import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalComponent } from "../../../global-component";
import { GenericGetData } from "../../../core/models/get-data.model";
import { Proceso } from "../models/proceso.model";
import { SaveProceso } from "../models/request/save-proceso.model";
import { EditProceso } from "../models/request/edit-proceso.model";
import { SelectOptionResponse } from 'src/app/shared/models/generic-entities.model';
@Injectable({
  providedIn: 'root'
})
export class ProcesoService {

  private urlService = 'configuraciones/proceso/';
  constructor(private http: HttpClient) { }

  getAll(page: number, pageSize: number, filter: string) {
    let urlFilter = page === 0 || pageSize === 0 ? "" : `?pageNumber=${page}&pageSize=${pageSize}&filter=${filter}`;
    return this.http.get<GenericGetData<Proceso[]>>(`${GlobalComponent.API_URL}${this.urlService}${"getall"}${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  getSelectOption() {
    return this.http.get<SelectOptionResponse[]>(`${GlobalComponent.API_URL}${this.urlService}select`, { reportProgress: true, observe: "events" });
  }

  save(data: SaveProceso) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"save"}`, data, { reportProgress: true, observe: "events" });
  }

  edit(data: EditProceso) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"edit"}`, data, { reportProgress: true, observe: "events" });
  }
}
